/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { useRootSelector } from '../../../hooks/useRootSelector';
import { useLocation } from '../../../hooks/useLocation';
import { OverlayModal } from '@components/OverlayModal/OverlayModal';
import { isNotaryRoute } from '@utils/routing';
import { getIsMobileEnabled } from '@utils/configs';

export namespace DisableMobileMode {
  export interface Props {}
}

export const DISABLE_MOBILE_VIEW_CONTENT = {
  contentLabel: 'Mobile Disabled',
  header: 'Oops, you need a bigger screen.',
  subHeader:
    'Blend Signing Room is not optimized for small screens. Please use a computer or zoom out on your computer browser to continue.',
};
export const DISABLE_MOBILE_DEVICE_CONTENT = {
  contentLabel: 'Device Disabled',
  header: 'Oops, you need a difference device.',
  subHeader: 'Blend Signing Room is not optimized for mobile device. Please use a computer to continue.',
};

export const DisableMobileMode: React.FC<DisableMobileMode.Props> = () => {
  const location = useLocation();
  const { isMobileView, isMobileDevice } = useRootSelector(state => state.layout);
  const isMobileEnabled = getIsMobileEnabled();
  const isNotary = isNotaryRoute(location.pathname);

  const isDisableMobileModalOpen = isMobileEnabled
    ? isNotary && (isMobileView || isMobileDevice)
    : (isNotary && isMobileDevice) || isMobileView;
  const disableModalContent = isNotary && isMobileDevice ? DISABLE_MOBILE_DEVICE_CONTENT : DISABLE_MOBILE_VIEW_CONTENT;

  return (
    <OverlayModal
      data-it="DisableMobileMode-Modal"
      isOpen={isDisableMobileModalOpen}
      header={disableModalContent.header}
      subHeader={disableModalContent.subHeader}
      contentLabel={disableModalContent.contentLabel}
    />
  );
};
